import {
  AHSeparator,
  AHText,
  AHWidgetTitle,
  Box,
  TouchableBox,
  useScaleFactor,
  useWidgetOptions,
} from "arkh";

import React, { useCallback } from "react";
import { FlatList, Platform } from "react-native";

import { graphql, useFragment } from "react-relay";
import { useSetWidgetFocus } from "../useSetFocus";

import { WidgetCalendar_widgetCalendar$key } from "./__generated__/WidgetCalendar_widgetCalendar.graphql";
import { WidgetCalendarEvent_teamScheduleOneOffEvent$key } from "./__generated__/WidgetCalendarEvent_teamScheduleOneOffEvent.graphql";
import { useWidgetLayoutContentSize } from "../useWidgetLayoutContentSize";
import { WidgetTeamScheduleTimeLabelLayout } from "../WidgetTeamSchedule/WidgetTeamScheduleTimeLabelLayout";
export const WidgetCalendar = (props: {
  widget: WidgetCalendar_widgetCalendar$key;
  storecastId?: string;
  mode?: "FOCUS" | "IDLE";

  interactive?: undefined | false;
}) => {
  const widget = useFragment(
    graphql`
      fragment WidgetCalendar_widgetCalendar on WidgetCalendar {
        id
        overviewSize
        events {
          id
          ...WidgetCalendarEvent_teamScheduleOneOffEvent
        }
      }
    `,
    props.widget
  );
  const setFocus = useSetWidgetFocus(widget.id, props.storecastId);
  const { background } = useWidgetOptions();

  type Item = (typeof widget.events)[number];

  const renderEvent = useCallback(
    ({ item }: { item: Item }) => (
      <WidgetCalendarEvent key={item.id} event={item} />
    ),
    []
  );

  return (
    <TouchableBox
      disabled={Platform.OS !== "web" && props.mode !== "FOCUS"}
      onPress={props.mode === "FOCUS" ? () => setFocus() : undefined}
      color="surface"
      style={{ flex: 1, backgroundColor: background }}
    >
      <AHWidgetTitle>Kalender</AHWidgetTitle>
      <FlatList
        automaticallyAdjustContentInsets={false}
        showsVerticalScrollIndicator={false}
        data={widget.events}
        renderItem={renderEvent}
        ItemSeparatorComponent={AHSeparator}
      />
    </TouchableBox>
  );
};

function WidgetCalendarEvent(props: {
  event: WidgetCalendarEvent_teamScheduleOneOffEvent$key;
}) {
  const event = useFragment(
    graphql`
      fragment WidgetCalendarEvent_teamScheduleOneOffEvent on TeamScheduleOneOffEvent {
        id
        startAtFormatted
        startAt
        endAtFormatted

        description
        title
      }
    `,
    props.event
  );

  const height = useWidgetLayoutContentSize().unit / 4;

  const sf = useScaleFactor();
  return (
    <Box
      spaceHorizontal="medium"
      style={{
        height,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Box
        style={{
          alignItems: "center",
          width: WidgetTeamScheduleTimeLabelLayout.width * sf,
        }}
      >
        <AHText type="subtitle">{event.startAtFormatted}</AHText>
        {event.endAtFormatted ? (
          <AHText type="body">{event.endAtFormatted}</AHText>
        ) : null}
      </Box>
      <AHText spaceLeft="large" numberOfLines={2} style={{ flex: 1 }}>
        <AHText style={{ width: "100%" }} type="title-small">
          {event.title}{" "}
        </AHText>
        <AHText type="body">
          {event.description?.replace(/\n/g, " ").replace(/\r/g, " ")}{" "}
        </AHText>
      </AHText>
    </Box>
  );
}
